import { useEffect, useState } from 'react'
import { getCaptcha } from '@/api/api'

export const useBeforeunload = (form, quillRef) => {
  useEffect(() => {
    const beforeunload = (event) => {
      const data = form.getFieldsValue()
      delete data.projectName
      const hasContent = Object.keys(data).some((item) => Boolean(data[item]))
      if (hasContent || quillRef.current.getText().trim()) {
        event.preventDefault()
        event.returnValue = ''
      }
    }

    window.addEventListener('beforeunload', beforeunload)
    return () => {
      window.removeEventListener('beforeunload', beforeunload)
    }
  }, [form, quillRef])
}

export const useCaptcha = () => {
  const [captchaImg, updateCaptchaImg] = useState(null)

  const get = () => {
    getCaptcha()
      .then((res) => {
        const blob = new window.Blob([res], {
          type: 'image/gif',
        })

        const reader = new FileReader()
        reader.onload = (e) => {
          updateCaptchaImg(e.target.result)
        }
        reader.readAsDataURL(blob)
      })
      .catch(() => {})
  }

  useEffect(get, [])

  return [captchaImg, get]
}
